import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {
  Chip,
} from '../..';
import FilterCreator from './FilterCreator';

const UnOrderedList = styled.ul`
  list-style-type: none;
  display: flex;
`;

const Li = styled.li`
  flex-wrap: wrap;
  flex: .04 0 auto;
`;

const propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      operatorText: PropTypes.string,
      type: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      options: PropTypes.array,
    }),
  ).isRequired,
  appliedFilters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  onQueryChange: PropTypes.func,
};

const defaultProps = {
  searchTerm: null,
  onQueryChange: null,
};

class FilterControl extends Component {
  handleAddFilter = (addedFilter) => {
    const { appliedFilters, onFilterChange } = this.props;

    const foundFilter = appliedFilters.find(
      appliedFilter => this.idFromFilter(appliedFilter) === this.idFromFilter(addedFilter),
    );

    if (!foundFilter) {
      const updatedFilters = [...appliedFilters, addedFilter];
      onFilterChange(updatedFilters);
    }
  }

  handleRemoveFilter = (filterId) => {
    const { appliedFilters, onFilterChange } = this.props;
    const filterIndex = appliedFilters.findIndex(filter => this.idFromFilter(filter) === filterId);
    if (filterIndex >= 0) {
      const updatedFilters = [
        ...appliedFilters.slice(0, filterIndex),
        ...appliedFilters.slice(filterIndex + 1, appliedFilters.length),
      ];
      onFilterChange(updatedFilters);
    }
  }

  idFromFilter = appliedFilter => `${appliedFilter.key}-${appliedFilter.value}`;

  getFilterLabel = (filters, appliedFilter) => {
    const { operatorText } = filters.find(filter => filter.key === appliedFilter.key);
    return `${appliedFilter.label} ${operatorText} ${appliedFilter.value}`;
  }

  render() {
    const {
      filters, appliedFilters, searchTerm, onQueryChange,
    } = this.props;
    let filteredTagsMarkup = null;
    if (appliedFilters && appliedFilters.length > 0) {
      filteredTagsMarkup = appliedFilters.map((appliedFilter) => {
        const filterId = this.idFromFilter(appliedFilter);
        return (
          <Li key={filterId}>
            <Chip onRemove={() => this.handleRemoveFilter(filterId)}>
              {this.getFilterLabel(filters, appliedFilter)}
            </Chip>
          </Li>
        );
      });
    }
    const filterTagsMarkupWrapper = appliedFilters && appliedFilters.length > 0 ? (
      <UnOrderedList>{filteredTagsMarkup}</UnOrderedList>
    ) : null;

    let filteredCreatorMarkup = null;
    if (filters && filters.length > 0) {
      filteredCreatorMarkup = (
        <FilterCreator
          filters={filters}
          onAddFilter={this.handleAddFilter}
          searchTerm={searchTerm}
          onQueryChange={onQueryChange}
        />
      );
    }
    return (
      <>
        {filteredCreatorMarkup}
        {filterTagsMarkupWrapper}
      </>
    );
  }
}

FilterControl.propTypes = propTypes;
FilterControl.defaultProps = defaultProps;
export default FilterControl;
